import { useState, useEffect, useRef } from 'react';
import TextInput from '../../shared/FormComponents/TextInput';
import AccountForm from '../../shared/UserAccountForm';
import { withLocalization } from '../../shared/Context/LocalizationContext';
import { useLocalization } from '../../custom-hooks/useLocalization';
import onLoad from '../../../utils/on-load';
import { compose } from '../../utils/compose';
import { withServerStyles } from '../../shared/ServerStylesConditionalWrapper';

const DEFAULT_STATE = {
  email: '',
  password: ''
};
const LoginComponent = (props) => {
  const [state, setState] = useState(DEFAULT_STATE);
  const refreshState = (newState) => setState({ ...state, ...newState });
  const recaptchaRef = useRef(null);
  const hiddenSubmitRef = useRef(null);

  const handleInput = (event) => {
    let updateState = {};
    updateState = { ...updateState, [event.target.name]: event.target.value };
    refreshState({ ...updateState });
  };

  const { resourceStrings } = useLocalization();

  useEffect(() => {
    onLoad().then(() => {
      if (props.email && !state.email) {
        let updateState = {};
        updateState = {
          ...updateState,
          email: props.email,
          loginUrl: window.location.href?.split('?')[0]
        };
        refreshState({ ...updateState });
      }
    });
  }, []);

  const getRecaptchaToken = async (e) => {
    e.preventDefault();
    try {
      const token = await new Promise((resolve, reject) =>
        window.grecaptcha.enterprise.ready(() => {
          window.grecaptcha.enterprise
            .execute(props.recaptchaSiteKey, {
              action: 'Login'
            })
            .then(resolve)
            .catch(reject);
        })
      );

      recaptchaRef.current.value = token;
    } catch (err) {
      console.log('error', err);
    } finally {
      hiddenSubmitRef.current.closest('form').submit();
    }
  };

  const handleEnterKeySubmit = (e) => {
    if (e.submitter === hiddenSubmitRef.current) {
      e.preventDefault();
      e.stopPropagation();
      getRecaptchaToken(e);
    }
  };

  useEffect(() => {
    if (hiddenSubmitRef.current) {
      hiddenSubmitRef.current
        .closest('form')
        .addEventListener('submit', handleEnterKeySubmit, { once: true });
    }
  }, []);

  return (
    <AccountForm
      heading={!props.requestedReset && props.meta.pageTitle}
      useDefaultSubmit={props.requestedReset}
      errorMessage={props.message}
      afterSubmit={
        !props.requestedReset && (
          // Show forgot password, and create account links, if not from requested reset
          <>
            <div className="form-field account-links">
              <ButtonLink
                text={resourceStrings['bdO.Login.ForgotPasswordLinkText']}
                link={
                  resourceStrings['bdO.Login.ForgotPasswordLink'] +
                  (state.email !== '' ? `?email=${state.email}` : '')
                }
                target="_self"
                type="tertiary"
                theme="light"
              />
              <ButtonLink
                text={resourceStrings['bdO.Login.CreateAccountLinkText']}
                link={resourceStrings['bdO.Login.CreateAccountLink']}
                target="_self"
                type="tertiary"
                theme="light"
              />
            </div>
          </>
        )
      }
    >
      {!props.requestedReset ? (
        // Normal login form, if not from requested reset
        <>
          <div className="form-field">
            <TextInput
              id="email"
              name="email"
              label={resourceStrings['bdO.Login.EmailLabel']}
              type="text"
              additionalAriaLabel="password-strength"
              onInput={handleInput}
              onBlur={handleInput}
              value={state.email}
              required
            />
          </div>
          <div className="form-field">
            <TextInput
              id="password"
              name="password"
              label={resourceStrings['bdO.Login.PasswordLabel']}
              type="password"
              additionalAriaLabel="password-strength"
              onInput={handleInput}
              onBlur={handleInput}
              value={state.password}
              required
            />
          </div>

          <div className="form-field">
            <input hidden id="gToken" name="gToken" type="text" ref={recaptchaRef} />
            <button className="btn btn-primary submit" type="button" onClick={getRecaptchaToken}>
              {resourceStrings['bdO.Login.LoginButtonText']}
            </button>
          </div>

          <button
            ref={hiddenSubmitRef}
            hidden
            className="hidden btn btn-primary submit"
            type="submit"
          ></button>
        </>
      ) : (
        <>
          <div className="form-field-no-margin-top">
            <div className="thank-you">
              <p>{resourceStrings['bdO.PasswordReset.ThankYou']}</p>
              <ButtonLink
                text="Login"
                link={state.loginUrl}
                target="_self"
                type="tertiary"
                theme="light"
              />
            </div>
          </div>
        </>
      )}
    </AccountForm>
  );
};

export default compose(withLocalization, withServerStyles)(LoginComponent);
